import {
  HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,
} from '@angular/common/http';
import { Injectable, Injector, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AUTH_ROUTE_TARGETS } from 'src/app/auth/@shared/auth-route-targets';
import { AuthService } from 'src/app/auth/@shared/auth.service';
import { ExternalReturnValue } from 'src/app/@core/types';
import { HttpStatusCode } from 'src/app/@shared/utils/http-status-code.enum';
import { NavController } from '@ionic/angular';
import { StorageService } from 'src/app/@core/storage.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private injector = inject(Injector);
  private navController = inject(NavController);
  private storage = inject(StorageService);

  public intercept(r: HttpRequest<ExternalReturnValue>, next: HttpHandler): Observable<HttpEvent<ExternalReturnValue>> {
    let request: HttpRequest<ExternalReturnValue> = r;
    const requestSkipsAuthentication = request.headers.get('x-skip-auth') === 'true';

    if (requestSkipsAuthentication) {
      request = request.clone({
        headers: request.headers.delete('x-skip-auth')
          .delete('Authorization'),
      });

      return next.handle(request);
    }

    const accessToken = this.storage.get('accessToken') as string;

    if (accessToken) {
      request = request.clone({
        headers: request.headers.set('Authorization', `Bearer ${accessToken}`),
      });
    }

    return next.handle(request).pipe(catchError((error: HttpErrorResponse) => {
      this.handleAuthError(error).catch();

      throw new HttpErrorResponse(error);
    }) as ExternalReturnValue);
  }

  private async handleAuthError(error: HttpErrorResponse): Promise<void> {
    if (error.status === HttpStatusCode.Unauthorized && this.storage.get('accessToken')) {
      console.info(`handled HttpStatusCode.Unauthorized ${error.status}`);

      const authService = this.injector.get(AuthService);

      await authService.logout(true);
      await this.navController.navigateRoot(AUTH_ROUTE_TARGETS.loginRedirect);

      return;
    }

    console.warn('unhandled error', error);
  }
}
